import {ACCESS_TOKEN, API_BASE_URL, POLL_LIST_SIZE} from '../constants';

const request = (options) => {
    const headers = new Headers({
        'Content-Type': 'application/json',
    })

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
    }

    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);

    return fetch(options.url, options)
         .then(async response => {
            let json;
            try {
                // Check if response has content before parsing
                const text = await response.text();
                json = text ? JSON.parse(text) : {};
            } catch (err) {
                // JSON parse error or empty response
                return Promise.reject({
                    message: "Invalid or empty JSON response",
                    status: response.status
                });
            }
            if (response.status === 401) {
                localStorage.removeItem(ACCESS_TOKEN);
                window.location.href = window.location.origin;
                return;
            }
            if (!response.ok) {
                return Promise.reject(json);
            }
            return json;
        });
};

export function getAllPayItems(date, category, page, size) {
    return category ? request({
        url: API_BASE_URL + "/chiti?date=" + date + "&category=" + category + "&page=" + page + "&size=" + size,
        method: 'GET'
    }) : request({
        url: API_BASE_URL + "/chiti?date=" + date + "&page=" + page + "&size=" + size,
        method: 'GET'
    });
}

export function getPayItemsByCategory(from, to, category, page, size) {
    return request({
        url: API_BASE_URL + "/chiti/category?from=" + from + "&to=" + to + "&category=" + encodeURIComponent(category) + "&page=" + page + "&size=" + size,
        method: 'GET'
    });
}

export function getPayItemsInRange(from, to, page, size) {
    return request({
        url: API_BASE_URL + "/chiti/range?from=" + from + "&to=" + to + "&page=" + page + "&size=" + size,
        method: 'GET'
    });
}

export function searchPayItems(keyword, page, size) {
    return request({
        url: API_BASE_URL + "/chiti/search?q=" + encodeURIComponent(keyword) + "&page=" + page + "&size=" + size,
        method: 'GET'
    });
}

export function getTygia() {
    return request({
        url: API_BASE_URL + "/common",
        method: 'GET'
    });
}

export function getAllCategories() {
    return request({
        url: API_BASE_URL + "/chiti/categories",
        method: 'GET'
    });
}


export function getAllPolls(page, size) {
    page = page || 0;
    size = size || POLL_LIST_SIZE;

    return request({
        url: API_BASE_URL + "/polls?page=" + page + "&size=" + size,
        method: 'GET'
    });
}

export function createPoll(pollData) {
    return request({
        url: API_BASE_URL + "/chiti",
        method: 'POST',
        body: JSON.stringify(pollData)
    });
}

export function updatePoll(pollData) {
    return request({
        url: API_BASE_URL + "/chiti/update",
        method: 'POST',
        body: JSON.stringify(pollData)
    });
}

export function castVote(voteData) {
    return request({
        url: API_BASE_URL + "/polls/" + voteData.pollId + "/votes",
        method: 'POST',
        body: JSON.stringify(voteData)
    });
}

export function login(loginRequest) {
    return request({
        url: API_BASE_URL + "/auth/signin",
        method: 'POST',
        body: JSON.stringify(loginRequest)
    });
}

export function signup(signupRequest) {
    return request({
        url: API_BASE_URL + "/auth/signup",
        method: 'POST',
        body: JSON.stringify(signupRequest)
    });
}

export function checkUsernameAvailability(username) {
    return request({
        url: API_BASE_URL + "/user/checkUsernameAvailability?username=" + username,
        method: 'GET'
    });
}

export function checkEmailAvailability(email) {
    return request({
        url: API_BASE_URL + "/user/checkEmailAvailability?email=" + email,
        method: 'GET'
    });
}


export function getCurrentUser() {
    if (!localStorage.getItem(ACCESS_TOKEN)) {
        return Promise.reject("No access token set.");
    }

    return request({
        url: API_BASE_URL + "/user/me",
        method: 'GET'
    });
}

export function getUserProfile(username) {
    return request({
        url: API_BASE_URL + "/users/" + username,
        method: 'GET'
    });
}

export function getUserCreatedPolls(username, page, size) {
    page = page || 0;
    size = size || POLL_LIST_SIZE;

    return request({
        url: API_BASE_URL + "/users/" + username + "/polls?page=" + page + "&size=" + size,
        method: 'GET'
    });
}

export function getUserVotedPolls(username, page, size) {
    page = page || 0;
    size = size || POLL_LIST_SIZE;

    return request({
        url: API_BASE_URL + "/users/" + username + "/votes?page=" + page + "&size=" + size,
        method: 'GET'
    });
}

export function getChitiOverviewOfCurrentMonth(date) {
    return request({
        url: API_BASE_URL + "/chiti/overview/current?date=" + date,
        method: 'GET'
    });
}

export function getChitiOverviewRange(from, to) {
    return request({
        url: API_BASE_URL + "/chiti/overview/range?from=" + from + "&to=" + to,
        method: 'GET'
    });
}

export function getCategoryPercentages(date) {
    return request({
        url: API_BASE_URL + "/chiti/report/percentages?date=" + date,
        method: 'GET'
    });
}

export function getCategoryPercentagesRange(from, to) {
    return request({
        url: API_BASE_URL + "/chiti/report/percentages/range?from=" + from + "&to=" + to,
        method: 'GET'
    });
}

export function getCardSpending(date) {
    return request({
        url: API_BASE_URL + "/chiti/report/card-spending?date=" + date,
        method: 'GET'
    });
}

export function getCardSpendingRange(from, to) {
    return request({
        url: API_BASE_URL + "/chiti/report/card-spending/range?from=" + from + "&to=" + to,
        method: 'GET'
    });
}

export function getDailySpending(date) {
    return request({
        url: API_BASE_URL + "/chiti/report/daily-spending?date=" + date,
        method: 'GET'
    });
}

//Notes
export function getNotes(page, size, folderId, sortBy = 'updatedAt', sortDir = 'desc') {
    let url = API_BASE_URL + "/note?page=" + (page || 0) + "&size=" + (size || 1000);
    if (folderId != null) url += "&folderId=" + folderId;
    url += "&sortBy=" + sortBy + "&sortDir=" + sortDir;
    return request({ url, method: 'GET' });
}

export function createNote(note) {
    return request({
        url: API_BASE_URL + "/note",
        method: 'POST',
        body: JSON.stringify(note)
    });
}

export function updateNote(noteId, note) {
    return request({
        url: API_BASE_URL + "/note/" + noteId,
        method: 'PUT',
        body: JSON.stringify(note)
    });
}

export function deleteNote(noteId) {
    return request({
        url: API_BASE_URL + "/note/" + noteId,
        method: 'DELETE'
    });
}

export function getFolders() {
    return request({ url: API_BASE_URL + "/folders", method: 'GET' });
}

export function createFolder(name) {
    return request({ url: API_BASE_URL + "/folders", method: 'POST', body: JSON.stringify({ name }) });
}

export function renameFolder(id, name) {
    return request({ url: API_BASE_URL + "/folders/" + id, method: 'PUT', body: JSON.stringify({ name }) });
}

export function deleteFolder(id) {
    return request({ url: API_BASE_URL + "/folders/" + id, method: 'DELETE' });
}

// Categories
export function getUserCategories() {
    return request({
        url: API_BASE_URL + "/categories",
        method: 'GET'
    });
}

export function createCategory(categoryData) {
    return request({
        url: API_BASE_URL + "/categories",
        method: 'POST',
        body: JSON.stringify(categoryData)
    });
}

export function deleteCategory(categoryId) {
    return request({
        url: API_BASE_URL + "/categories/" + categoryId,
        method: 'DELETE'
    });
}

export function updateCategory(categoryId, categoryData) {
    return request({
        url: API_BASE_URL + "/categories/" + categoryId,
        method: 'PUT',
        body: JSON.stringify(categoryData)
    });
}

// Cards
export function getUserCards() {
    return request({
        url: API_BASE_URL + "/cards",
        method: 'GET'
    });
}

export function createCard(cardData) {
    return request({
        url: API_BASE_URL + "/cards",
        method: 'POST',
        body: JSON.stringify(cardData)
    });
}

export function deleteCard(cardId) {
    return request({
        url: API_BASE_URL + "/cards/" + cardId,
        method: 'DELETE'
    });
}
